import axios from 'axios';
import { PREFIX_URL } from './config';
import { generateRoutePath } from '../routes';

const URLS = {};

URLS.BASE_URL = `${PREFIX_URL}/users`;
URLS.USER_ID = `${URLS.BASE_URL}/:userId`;
URLS.USER_NOTIFICATION_SETTINGS = `${URLS.USER_ID}/notification-settings`;
URLS.NOTIFICATIONS = `${URLS.USER_ID}/notifications`;
URLS.ARCHIVE_ALL_NOTIFICATIONS = `${URLS.NOTIFICATIONS}/archive-all`;
URLS.READ_ALL_NOTIFICATIONS = `${URLS.NOTIFICATIONS}/read-all`;
URLS.ARCHIVED_NOTIFICATIONS = `${URLS.NOTIFICATIONS}/archived`;

export const fetchNotifications = async (userId, params) => {
  const url = generateRoutePath(URLS.NOTIFICATIONS, { userId });

  return await axios
    .get(url, { params })
    .then((res) => res.data)
    .catch((error) => {
      console.error(error);
    });
};

export const fetchArchivedNotifications = async (userId, params) => {
  const url = generateRoutePath(URLS.ARCHIVED_NOTIFICATIONS, { userId });

  return await axios
    .get(url, { params })
    .then((res) => res.data)
    .catch((error) => {
      console.error(error);
    });
};

export const updateNotificationSettings = (userId, params) => {
  const url = generateRoutePath(URLS.USER_NOTIFICATION_SETTINGS, { userId });

  return axios.put(url, params);
};

export const fetchNotificationSettings = async (userId) => {
  const url = generateRoutePath(URLS.USER_NOTIFICATION_SETTINGS, { userId });

  return axios.get(url).then((res) => res.data);
};

export const archiveAllNotifications = async (userId, params) => {
  const url = generateRoutePath(URLS.ARCHIVE_ALL_NOTIFICATIONS, { userId });

  return axios.post(url, null, { params });
};

export const readAllNotifications = async (userId, params) => {
  const url = generateRoutePath(URLS.READ_ALL_NOTIFICATIONS, { userId });

  return axios.post(url, null, { params });
};
